import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const CustomIconToolTip = ({
  target,
  toolTipText,
  icon,
  iconClassName,
  onClick,
  color,
  placement,
  tooltipClassName,
}) => (
  <React.Fragment>
    <FontAwesomeIcon
      icon={icon}
      id={target}
      className={iconClassName}
      onClick={onClick}
      color={color}
    />
    <UncontrolledTooltip
      className={tooltipClassName}
      placement={placement}
      target={target}
    >
      {toolTipText}
    </UncontrolledTooltip>
  </React.Fragment>
);

CustomIconToolTip.defaultProps = {
  toolTipText: '',
  icon: '',
  iconClassName: '',
  onClick: () => {},
  color: 'black',
  placement: 'right',
  tooltipClassName: '',
};

CustomIconToolTip.propTypes = {
  target: PropTypes.string.isRequired,
  toolTipText: PropTypes.string,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
  placement: PropTypes.string,
  tooltipClassName: PropTypes.string,
};

export default CustomIconToolTip;



// WEBPACK FOOTER //
// ./src/components/tooltip/customToolTip.js